<form name="targetForm" [formGroup]="targetForm">
    <header class="info-tile-alt heading-row">
        <div class="title-container">
            <h2 *ngIf="isAddActivity"><b>Create New Activity</b></h2>
            <h2 *ngIf="!isAddActivity"><b>Edit an Activity</b></h2>
        </div>
        <div class="drawer-close" (click)="rightSideDrawerService.closeRightSideDrawer()"><i class="fas fa-times"
                aria-hidden="true"></i></div>
    </header>
    <section class="sideRight-body">

        <div id="container">
            <div id="contentC">
                <label>
                    <i class="fas fa-asterisk"></i><b> Activity Name</b>
                    <span *ngIf="f.name.errors && f.name.touched">
                        <span class="required-error" *ngIf="f.name.errors.required">
                            (Required)
                        </span>
                        <span class="required-error" *ngIf="f.name.dirty && f.name.errors.UniqueAName">
                            (Activity name exists)
                        </span>
                    </span>
                    <input class="black-input opposite-colors" type="text" no-special-chars="<>" maxlength="100"
                        (input)="activityNamechange();OnActivityChange()" (blur)="trimSpecialChar('name')"
                        formControlName="name" required placeholder="Name must be unique">
                </label>
            </div>
        </div>

        <div id="container" style="margin-bottom: 1em;">
            <div id="contentA"  class="ei-employeeNumber mt-2">
                <label>
                    <i class="fas fa-asterisk"></i><b> Activity Type</b>
                    <span class="required-error" *ngIf="showActivitySubTypeValidation">
                            (Required)
                    </span>
                </label>
                    <div class="input-icon-right" [ngClass]="{'error-section': showActivitySubTypeValidation}">
                        <custom-dropdown [options]="dropdownOptions" [selectText]="selectedActivitySubType" class="dropdown-section"
                          [buttonHeight]="true" [isDisabled]="disableActivitySubtype" (optionSelectedEvent)="onActivitySubTypeSelected($event)">
                        </custom-dropdown>
                    </div> 
            </div>
            <div id="contentB" class="ei-name mt-2" style="
            padding-top: 37px;
            display: flex;
            align-items: flex-end;">
                <label style="width: 70%;">
                    <i class="fas fa-asterisk"></i><b> Qualified %</b><br />
                </label>
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors" placeholder="100" min="0" max="100" value="100"
                            (input)="OnActivityChange()" formControlName="qpercentage" type="number" required>
                        <i class="fas fa-percent" style="left: 68%;"></i>
                    </div>
            </div>
        </div>
        
        <div 
            *ngIf="f.qpercentage.errors && f.qpercentage.errors.pattern || (f.qpercentage.touched && !f.qpercentage.valid && !isNQA)">
            <div class="error-message" *ngIf="f.qpercentage.touched && !f.qpercentage.valid && !isNQA">
                Qualified % must be a number between 0-100, and can have up to two decimal places.
            </div>
        </div>

        <div id="container">
            <div id="contentC">
                <label>
                    <i class="fas fa-asterisk"></i><b> Activity Group</b>
                    <span *ngIf="f.activityGroup.errors && f.activityGroup.touched">
                        <span class="required-error" *ngIf="f.activityGroup.errors.required">
                            (Required)
                        </span>
                    </span>
                    <input class="black-input opposite-colors clients-autocomplete"
                        [ngClass]="{'ng-invalid' :  !isActivityGroupSelected }"
                        placeholder="Search for an existing group or enter a new group" type="text"
                        no-special-chars="#!$%^<>+=" [kpmgUiTypeahead]="searchExistingActivityGroup"
                        [resultTemplate]="ag" [editable]="true" (input)="OnActivityChange()"
                        [inputFormatter]="ActivityGroupFormatter"
                        (blur)="activityGroupValidationDelayer($event.target.value)" formControlName="activityGroup">

                    <ng-template #ag let-c="result" let-t="term">
                        <kpmg-ui-highlight class="create-engagement-typeahead" [result]="c.activityGroup" [term]="t">
                        </kpmg-ui-highlight>&nbsp;
                    </ng-template>
                    <!-- <input class="black-input opposite-colors" type="text" no-special-chars="#!$%^<>+='" (input)="trimSpecialChar('activityGroup');"  maxlength="100" formControlName="activityGroup" required> -->
                </label>
            </div>
        </div>

        


        <div id="container">
            <div id="contentC">
                <label>
                    <b>Activity Description</b>
                    <textarea class="black-input opposite-colors" placeholder="A maximum of 500 characters is allowed."
                        rows="5" no-special-chars="#!$%^<>+='" maxlength="500" (input)="OnActivityChange()"
                        formControlName="description"></textarea>
                </label>
            </div>
        </div>

        

    </section>
    <footer class="endFormSubmit info-tile">
        <button *ngIf="isAddActivity" type='button' class="btn btn-success"
            [disabled]="isBtnDisabled()" (click)="addEditActivity(true)">Create</button>
        <button *ngIf="!isAddActivity" type='button' class="btn btn-success"
            [disabled]="(!targetForm.valid || isDisabled)" (click)="addEditActivity(false)">Save Changes</button>
        <button class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
    </footer>
</form>